import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return {
		root: {
			display: "flex",
			flexDirection: "column",
			gap: theme.spacing(1),
		},
		input: {
			maxWidth: 340,
		},
	} satisfies Record<string, CSSObject>;
};
